// extracted by mini-css-extract-plugin
export default {"background":"PR","weightImage":"QR","drinkImage":"RR","content":"SR","rtbLeft":"TR","rtbRight":"UR","rtbLeftMobile":"VR","imageContainer":"WR","rtbBox":"XR","line":"YR","rtbDesktop":"ZR"};
    if(module.hot) {
      // 1738836197405
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  